import MenuOptions from '@/@straico-ui/commons/MenuOptions';
import useThemeStore from '@/Theme/store';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { MenuItem } from '@mui/material';
import { memo } from 'react';
import { defaultMenuOptionsProps, getIconModelSelector } from '../utils';
import ActionButton from './ActionButton';
import ModelParameter from './ModelParameter';

const ModelSelector = ({
  type,
  icon,
  name,
  models,
  selectedModel,
  setSelectedModel,
  setGenerationsModelsActive,
  selectedModelParameters,
  setSelectedModelParameters,
  customFunction,
}) => {
  const { theme } = useThemeStore();
  const isActive = selectedModel?.type?.toLowerCase() === type.toLowerCase();

  return (
    <>
      <MenuOptions
        {...defaultMenuOptionsProps}
        title={
          <div className="relative group">
            <ActionButton
              icon={icon}
              text={isActive ? selectedModel?.name : name}
              active={isActive}
              className="w-max"
            />
            {isActive && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedModel(null);
                  setSelectedModelParameters(null);
                  setGenerationsModelsActive(false);
                }}
                className="absolute -bottom-1 -right-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-white rounded-full p-0.5 shadow-sm hover:bg-gray-100"
              >
                <XMarkIcon className="size-3 text-gray-500" />
              </button>
            )}
          </div>
        }
        customChildren={(handleClose) => (
          <>
            {models.map((model) => (
              <MenuItem
                selected={selectedModel?._id === model._id}
                key={model._id}
                onClick={() => {
                  if (model._id === selectedModel?._id) {
                    setGenerationsModelsActive(false);
                    setSelectedModel(null);
                    setSelectedModelParameters(null);
                    handleClose();
                  } else {
                    customFunction && customFunction();
                    setGenerationsModelsActive(true);
                    setSelectedModel(model);
                    setSelectedModelParameters(null);
                    handleClose();
                  }
                }}
              >
                <div className="flex flex-col w-full">
                  <div className="flex items-center justify-between w-full">
                    <div className="flex items-center">
                      <div
                        className={`flex size-7 items-center self-start mt-1 gap-1 font-figtree font-bold text-xs text-white dark:text-umbra uppercase mr-2 p-1 bg-${
                          model.color ? `[${model.color}]` : 'nue-blue'
                        } rounded-lg`}
                      >
                        {getIconModelSelector(model, 'white', 6)}
                      </div>
                      <span className="text-wrap line-clamp-2 text-left">
                        {model.name}
                      </span>
                    </div>
                  </div>
                  {model.model_pros && (
                    <span
                      className={`text-xs ${
                        theme !== 'dark'
                          ? 'text-[#51526C]'
                          : 'dark:text-[#b0b0b0]'
                      } mt-1 block text-wrap line-clamp-1 md:line-clamp-3`}
                    >
                      {model?.model_pros?.join(', ')}
                    </span>
                  )}
                </div>
              </MenuItem>
            ))}
          </>
        )}
      />
      {isActive && (
        <>
          {selectedModel.parameters
            ?.filter((param) => param.property !== 'prompt')
            .map((parameter) => (
              <ModelParameter
                key={parameter.property}
                parameter={parameter}
                selectedModelParameters={selectedModelParameters}
                setSelectedModelParameters={setSelectedModelParameters}
              />
            ))}
        </>
      )}
    </>
  );
};

export default memo(ModelSelector);
